exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.crearEndpoint #alinear[data-v-38e3dd3f] {\n  text-align: justify;\n}\n.crearEndpoint .h2_title[data-v-38e3dd3f] {\n  font-weight: normal;\n}\n", ""]);

// exports
